import { useEffect, useState } from 'react';

const PENDING_DESCRIPTION_DOTS = ['.', '..', '...'];
const loadingDotsStyle = {
  animation: 'descriptionPulse 1.6s ease-in-out infinite',
  '@keyframes descriptionPulse': {
    '0%, 100%': {
      opacity: 0.55,
    },
    '50%': {
      opacity: 1,
    },
  },
};

const useLoadingDots = (isLoading: boolean) => {
  const [pendingDotsIndex, setPendingDotsIndex] = useState(0);

  useEffect(() => {
    let intervalId: number | undefined;

    if (!isLoading) {
      setPendingDotsIndex(0);
    } else {
      intervalId = window.setInterval(() => {
        setPendingDotsIndex((currentIndex) => currentIndex + 1);
      }, 500);
    }

    return () => {
      if (intervalId) {
        window.clearInterval(intervalId);
      }
    };
  }, [isLoading]);

  const loadingDots = PENDING_DESCRIPTION_DOTS[pendingDotsIndex % PENDING_DESCRIPTION_DOTS.length];
  return { loadingDots, loadingDotsStyle };
};

export default useLoadingDots;
